import React, { createContext, useContext, useState } from 'react';

interface RefreshKeyContextType {
  refresh_key: number;
  updateRefreshKey: () => void;
}

const RefreshKeyContext = createContext<RefreshKeyContextType | undefined>(undefined);
const fallback_refresh_key = Date.now();

export const RefreshKeyProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [refresh_key, setRefreshKeyState] = useState<number>(() => new Date().getTime());

  const updateRefreshKey = () => {
    setRefreshKeyState(new Date().getTime());
  };

  return (
    <RefreshKeyContext.Provider value={{ refresh_key, updateRefreshKey }}>
      {children}
    </RefreshKeyContext.Provider>
  );
};

export const useRefreshKey = (): RefreshKeyContextType => {
  const context = useContext(RefreshKeyContext);
  if (context === undefined) {
    return {
      refresh_key: fallback_refresh_key,
      updateRefreshKey: () => {
        // Fallback for when the context is not available
      },
    };
  }
  return context;
};
